<template>
  <p class="clearfix mb-0">
    <span class="float-md-left d-block d-md-inline-block mt-25">
      Copyright  © {{ new Date().getFullYear() }}
      <b-link
        class="ml-25"
        href="https://tapp.be"
        target="_blank"
      >Tapp</b-link>
      <span class="d-none d-sm-inline-block">, Alle rechten voorbehouden</span>
    </span>

    <span class="float-md-right d-none d-md-block">Gemaakt met<feather-icon
        icon="HeartIcon"
        size="21"
        class="text-danger stroke-current"
      />
      {{$store.state.organisation ? ` voor ${$store.state.organisation.shortName}` : ''}}
    </span>
  </p>
</template>

<script>
import { BLink } from 'bootstrap-vue'

export default {
  components: {
    BLink,
  },
}
</script>
